var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-bg page-bg-album"},[_vm._m(0),_c('div',[_c('i-nav')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex1 f-pr"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","position":"absolute","left":"0","top":"0","border":"none"},attrs:{"src":"https://alltuu.cc/album/52e52d087cfcaaa24ea97ff7cedb0e07/?menu=live"}})])
}]

export { render, staticRenderFns }